export const SPECIES_LIST = [
  { code: 'AMCR', label: 'American Crow' },
  { code: 'AMKE', label: 'American Kestrel' },
  { code: 'BANO', label: 'Barn Owl' },
  { code: 'COHA', label: "Cooper's Hawk" },
  { code: 'CORA', label: 'Common Raven' },
  { code: 'GHOW', label: 'Great Horned Owl' },
  { code: 'MALL', label: 'Mallard' },
  { code: 'PEFA', label: 'Peregrine Falcon' },
  { code: 'RSHA', label: 'Red-shouldered Hawk' },
  { code: 'RTHA', label: 'Red-tailed Hawk' },
  { code: 'WEGU', label: 'Western Grebe' },
  { code: 'WESO', label: 'Western Screech-Owl' },
];
